import { BuyerProjectData } from '@/types';

export type BuyerProjectDataReducer = Readonly<BuyerProjectData> | null;

// const initialState: BuyerProjectDataReducer = {
//     unitType: 'Apartment',
//     sellerProfileName: '',
//     projectName: '',
//     projectId: 0,
//     deadlines: [],
//     unitName: '',
//     sellerProfileId: 0,
//     features: null,
//     changeRequestWarningText: null,
//     changeRequestDeadline: null,
//     currencyCode: '',
//     forceStyleSelection: false,
//     mainOptionPresetId: null,
//     sellerModules: [],
//     buyerModules: []
// };

const initialState: BuyerProjectDataReducer = null;

const buyerData = (state: BuyerProjectDataReducer = initialState, action): BuyerProjectDataReducer => {
    switch (action.type) {
        case 'SET_PROJECT_DATA':
            return action.data;
        // case 'SET_SELECTED_MAIN_STYLE':
        //     return { ...state! };
        default:
            return state;
    }
};

export default buyerData;
